export const bankType = 'ach';
